import { render, staticRenderFns } from "./UserAddButton.vue?vue&type=template&id=32314922&"
import script from "./UserAddButton.vue?vue&type=script&lang=js&"
export * from "./UserAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports